export { default } from "./ReminderIcon";
